<template>
    <div>
        <div class="row justify-content-center" v-if="programmes.length > 0">
            <div class="col-md-12">
                <h2 class="title">Events <small>List</small></h2>
            </div>
            <div class="col-md-12" v-for="(programme, index) in programmes" :key="index">
                <PreviewCard v-bind="programme" entity="programme" v-on:card-click="onCardClick" :showFooter="false" card-type="long"></PreviewCard>
            </div>
        </div>
        <div class="row justify-content-center mt-5" v-else>
            <div class="col-md-6">
                <h1 class="text-white" style="margin-bottom: 0;"><strong>Loading...</strong></h1>
                <h2 class="text-white">We are fetching the details for you. It'll be just a moment.</h2>
            </div>
        </div>
    </div>
</template>

<script>
import { PreviewCard } from 'src/components';
import { mapGetters } from 'vuex';

export default {
    name: 'RegisterHome',
    components:{
        PreviewCard
    },
    mounted(){
        this.$store.dispatch('getUserProgrammes')
    },
    computed: {
        ...mapGetters({
            programmes: 'getProgrammes',
            authTokens: 'getAuthTokens',
            preferences: 'getPreferences'
        }),
    },
    methods: {
        onCardClick(link){
            this.$router.push(`/register-${link}`)
        }
    }
}
</script>

<style>

</style>
